var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34911 8.66633C8.85969 8.56414 8.40967 8.37422 8.01293 8.10313C7.82055 7.967 7.54612 7.98363 7.34326 8.12794L6.18115 8.73944C5.35956 7.87524 4.95209 6.96011 4.80219 5.6405L5.80196 4.745C6.0326 4.58395 6.18603 4.30976 6.20238 4.02637C6.22689 3.45734 6.33442 2.87732 6.52214 2.30304C6.65483 1.89711 6.48178 1.5081 6.13642 1.43598L4.67485 1.13079C4.32949 1.05868 3.94048 1.33033 3.80779 1.73626C2.25965 6.47236 4.27849 11.0105 8.30782 11.8519C8.65317 11.924 9.04218 11.6523 9.17487 11.2464L9.73483 9.53339C9.86752 9.12746 9.69447 8.73845 9.34911 8.66633Z",
    fill: "#FF7B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6a7a2ec61e5258b99d5e3a7841871a92.svg";
export { ForwardRef as ReactComponent };